<template>
  <StepLayout
    :title="`${keyword}に関して他にも気になることがあれば教えてください`"
    :current-step="4"
    @back="handleBack"
  >
    <div class="step-free-text">
      <textarea
        v-model="model"
        class="step-free-text__textarea"
        :placeholder="placeholder"
        maxlength="470"
        aria-describedby="step-free-text-description"
      />

      <div class="step-free-text__counter">残り{{ remainingChars }}文字</div>

      <p id="step-free-text-description" class="step-free-text__hint">
        入力は任意ですが、詳しく入力すると検索精度が上がります
      </p>
    </div>

    <template #footer>
      <button
        type="button"
        class="button button--primary button--full button--lg step-free-text__search-button"
        @click="handleSearch"
      >
        あなたと似ている相談をみる
        <i class="material-icons" aria-hidden="true">search</i>
      </button>
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import StepLayout from './StepLayout.vue';
import { VALIDATION } from '../types';

defineProps<{
  keyword: string;
}>();

const model = defineModel<string>({ default: '' });

const emit = defineEmits<{
  search: [];
  back: [];
}>();

const placeholder = `例）朝起きたときに症状が一番辛くなり、ズキズキと痛みます
例）健康診断では肝臓の数値が良くないと言われています`;

const remainingChars = computed(() => {
  const currentLength = model.value.length;
  return VALIDATION.MAX_FREE_TEXT_LENGTH - currentLength;
});

const handleSearch = () => {
  emit('search');
};

const handleBack = () => {
  emit('back');
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.step-free-text {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 1rem;
    resize: vertical;
    min-height: 15rem;
    font-family: inherit;

    &::placeholder {
      color: $quaternary-font-color;
    }

    &:focus {
      outline: none;
      border-color: $primary-color;
      box-shadow: 0 0 0 2px rgba($primary-color, 0.2);
    }
  }

  &__counter {
    text-align: right;
    font-size: 0.875rem;
    color: $tertiary-color;
  }

  &__hint {
    font-size: 0.875rem;
    color: #d32f2f;
    margin: 0 auto;
    max-width: 90%;
  }

  &__search-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .material-icons {
      font-size: 1.875rem;
    }
  }
}
</style>
